/* eslint-disable @typescript-eslint/ban-ts-comment */
import useSWR from 'swr'
import { WebcastResponse, defaultState } from '../fetchWebcast'
import fetcher from '../fetcher'
import convertDuration from '../convertDuration'
import convertMinutesToMilliseconds from '../convertMinutesToMilliseconds'
import useGigIDs from '../useGigIDs'

/** Will pass the initial state from the PageContent object, then revalidate. Subsequent calls won't need to pass initial state as it will be cached */
const useWebcast = (initialData = defaultState, hostUrl = '') => {

  const { channelId, webcastId } = useGigIDs()

  // @ts-ignore
  return useSWR<WebcastResponse, any>(channelId && webcastId ? [ 'webcast', hostUrl, '', channelId, webcastId ] : null, fetcher, {
    onErrorRetry: (error, key, config, revalidate, { retryCount }) => {

      if (error?.status === 404) return

      if (retryCount >= 10) return

      // Retry every minute on failure
      setTimeout(() => revalidate({ retryCount: retryCount + 1 }), convertMinutesToMilliseconds(2))

    },
    initialData,
    revalidateOnMount: true,
    revalidateOnFocus: false,
  })

}

export default useWebcast
